<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <section ref="scrollElement" :class="containerStyles">
    <paragraph
      :is-umbraco="isUmbraco"
      theme="light"
      :text="label"
      classes="font-bold col-start-2 col-span-12 md:col-start-5 md:col-span-6 mb-5"
    />
    <div class="col-start-2 col-span-12 md:col-start-5 md:col-span-6">
      <icon-link
        v-for="link in shareLinks"
        theme="light"
        :url="link?.url"
        :icon="link?.icon"
        :is-umbraco="isUmbraco"
        :label="link?.icon"
        classes="mr-5"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { Theme } from "@/types/types";
import Paragraph from "@components/Typography/Paragraph.ce.vue";
import IconLink from "@atoms/IconLink/IconLink.ce.vue";
import { getSoMeShareLinks } from "@/util/helper";

import { computed, toRefs, ref } from "vue";

export interface socialModuleProps {
  label: string;
  isUmbraco?: boolean;
  url: string;
  icons: object[];
  vacancypage?: boolean;
}

const props = withDefaults(defineProps<socialModuleProps>(), {
  isUmbraco: false,
});

const theme = ref("sand" as Theme);
const { label, url, icons, isUmbraco, vacancypage } = toRefs(props);
const shareLinks = getSoMeShareLinks(url.value, icons.value as { icon: string }[]);

const containerStyles = computed(() => {
  const bgColor = isUmbraco.value ? `bg-${theme.value}` : ``;
  if (!vacancypage.value === true)
    return `${bgColor} sectionContainer lg:min-h-full py-10`;
  return `${bgColor} lg:min-h-full py-10`;
});
</script>
